import React from "react";

import CloseIcon from "@uui/XClose";

import {
  Card,
  Modal as MuiModal,
  ModalProps as MuiModalProps,
} from "@mui/material";
import styled from "@mui/material/styles/styled";

import IconButton, { IconButtonProps } from "@rui/IconButton";

export interface ModalProps extends Omit<MuiModalProps, "onClose"> {
  onClose?: MuiModalProps["onClose"];
}

const StyledCard = styled(Card)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "95%",
  maxHeight: "95%",
  overflowY: "auto",
});

export const ModalCloseButton = styled<React.FC<IconButtonProps>>((props) => (
  <IconButton {...props}>
    <CloseIcon />
  </IconButton>
))(({ theme }) => ({
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: "8px",
  height: "32px",
  width: "32px",
}));

// TODO: replace the "common" Modal component with this one
const Modal = ({ children, sx, ...modalProps }: ModalProps) => (
  <MuiModal disableAutoFocus {...modalProps}>
    <StyledCard sx={sx}>{children}</StyledCard>
  </MuiModal>
);

export default Modal;
